/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Export_Csv_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not export the table as CSV." |
*
* @param {Datasets_Export_Csv_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_export_csv_error = /** @type {((inputs?: Datasets_Export_Csv_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Export_Csv_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Tabelle konnte nicht als CSV exportiert werden.")
	return /** @type {LocalizedString} */ ("Could not export the table as CSV.")
});